const COOKIE = "ct_session";
const ONE_YEAR = 60 * 60 * 24 * 365;

function uuid(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) return crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function readCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  const m = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}

function writeCookie(name: string, value: string) {
  if (typeof document === "undefined") return;
  document.cookie = `${name}=${encodeURIComponent(value)};path=/;max-age=${ONE_YEAR};SameSite=Lax`;
}

export function getOrCreateSessionId(): string {
  if (typeof document === "undefined") return "";
  let id = readCookie(COOKIE);
  if (!id) { id = uuid(); writeCookie(COOKIE, id); }
  return id;
}

export function readSessionId(): string | null {
  return readCookie(COOKIE);
}
